import { render, staticRenderFns } from "./promotion_panicbuy.vue?vue&type=template&id=425e91fb&scoped=true&"
import script from "./promotion_panicbuy.vue?vue&type=script&lang=ts&"
export * from "./promotion_panicbuy.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_panicbuy.vue?vue&type=style&index=0&id=425e91fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e91fb",
  null
  
)

export default component.exports